module.exports = ".pageNotFound{\r\n    width: 60%;\r\n    margin: 0% 22%;\r\n}"